import type { Evento } from "../../types/evento";
import { apiClient } from "../core/apiClient";

interface getEventsResult {
  data: Evento[];
  pagination: {
    currentPage: number,
    totalPages: number,
    totalItems: number,
    itemsPerPage: number,
    itemsInCurrentPage: number,
    hasNextPage: boolean,
    hasPreviousPage: boolean,
    nextPage: string | null,
    previousPage: string | null
  }
  loading: boolean;
  error: string | null;
  total: number;
  totalPages: number;
  refetch: () => void;
}

export class EventService {
  async getEvents(params?: { name_persona?: string; page?: number; status_persona_id?: number, tipo_persona_id?: string }): Promise<getEventsResult> {
    const queryString = params ? new URLSearchParams(params as any).toString() : '';
    const endpoint = `/eventos-accesos${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get<getEventsResult>(endpoint);
    return response.data;
  }

  // async createPerson(namePerson: string): Promise<postPersonResult> {
  //   const response = await apiClient.post<postPersonResult>('/personas/add', { "name": namePerson });
  //   return response.data;
  // }

  // async addProveedorPerson(proveedorData: ProveedorPersonFormData): Promise<Boolean> {
  //   const response = await apiClient.post<postPersonResult>('/personas/add-type-proveedor', proveedorData);
  //   return response.state;
  // }

  // async addPhotoPerson(userId: string, file: File): Promise<Boolean> {
  //   const response = await apiClient.uploadFile<{ avatarUrl: string }>(`/personas/add-photo/${userId}`, file);
  //   return response.state;
  // }

  // async syncFacial(facialId: string): Promise<Boolean> {
  //   const response = await apiClient.get<getPersonResult>(`/sincronizar-facial/${facialId}`);
  //   return response.state;
  // }

  // async updatePersonStatus(personId: string, statusId: number): Promise<void> {
  //   const response = await apiClient.post(`/personas/change-status`, {
  //     employeeNo: personId,
  //     status: statusId  // 1 = Activo, 2 = Inactivo
  //   });
  //   return response.data;
  // }
}

export const eventService = new EventService();